import { useAppSelector } from '@common/hooks'
import { type ReactNode } from 'react'
import { useMemo } from 'react'


interface IProps {
  children: ReactNode[];
  href: string;
}

export default function MarkdownLink({
  children,
  href,
}: IProps): JSX.Element | null {
  const cbUrl = useAppSelector(store => store.common.data?.config?.CB_WEB_URL)
  const processedLink = useMemo(() => {
    if(!cbUrl) {
      return href
    }
    const chaturbateRegex = /^(?:https?:\/\/)?([\w-]+\.)*chaturbate\.com(\/.*)?$/
    if(chaturbateRegex.test(href) || href.includes(cbUrl)) {
      return href
    } else {
      return `${cbUrl}/external_link/?url=${encodeURIComponent(href)}`
    }
  }, [href, cbUrl])

  if(children === null) {
    return null
  }
  return (
    <a
      href={processedLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children[0]}
    </a>
  )
}
